/**
 * Created by szaman on 1/22/2016.
 */
/// <reference path="../app.definition.ts" />

import moment from "moment";

/**
 * Created by szaman on 12/3/2015.
 */

    export class Util {

        public static teamRoles = [];
        public static projectTypes = [];
        public static youtubeUrlRegex = /^https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)[\w-]+(?:\?si=[\w-]+)?/;
        public static serviceLocations = [];
        constructor() {

        }

        static reset() {
            Util.teamRoles = [];
            Util.projectTypes = [];
            Util.serviceLocations = [];
        }
        // sleep time expects milliseconds
        static sleep(time) {
            return new Promise((resolve) => setTimeout(resolve, time));
        }


        static htmlEscape(str) {
            return str
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/'/g, '&#39;')
                .replace(/`/g, '&#96;')

                .replace(/(\r\n|\n|\r)/gm, '&#13;')
                //.replace(/@/g, '&#39;')
                .replace(/</g, '&lt;')
                .replace('+', '&#43;')
                .replace(/\\/g, '&#92;')
                .replace(/\//g, '&#47;')
                .replace(/%/g, '&#37;')
                .replace(/>/g, '&gt;')
                .replace(/\t/g, '&#9;');
        }

        //Here the characters which are not escaped like '%,;,\\,/' are not stored as escaped in DB
        //so not escaping them
        static documentSearchTextEscape(str){
            return str
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&#34;')
                .replace(/'/g, '&#39;')
                .replace(/'/g, '&#39;')
                .replace(/`/g, '&#96;')
                .replace(/@/g, '&#64;')
                .replace(/</g, '&lt;')
                .replace('+', '&#43;')
                .replace(/>/g, '&gt;')
        }

        // I needed the opposite function today, so adding here too:
        static htmlUnescape(str) {
            return str
                .replace(/&quot;/g, '"')
                .replace(/&#61;/g, '=')
                .replace(/&#96;/g, '`')
                .replace(/&#13;/g, '</br>')
                .replace(/&#34;/g, '"')
                .replace(/&#64;/g, '@')
                .replace(/&#39;/g, "'")
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&#43;/g, '+')
                .replace(/&#47;/g, '/')
                .replace(/&#37;/g, '%')
                .replace(/&#92;/g, '\\')
                .replace(/&amp;/g, '&')
                .replace(/&#9;/g, '\t');
        }

        static objectEscape(obj: any) {
            if (!obj) {
                return;
            }
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];
                    // This condition checks if the value is an object or an array.
                    if (value && typeof value === 'object') {
                        this.objectEscape(value);
                    }

                    if (typeof value === 'string' && key.indexOf('photo') === -1 && key !== 'thumbnail' && key !== 'content') {
                        obj[key] = this.htmlEscape(value);
                    }
                }
            }
        }

        static objectUnEscape(obj: any) {
            if (!obj) {
                return;
            }

            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];

                    // This single condition correctly identifies nested objects and arrays
                    // while safely excluding null.
                    if (value && typeof value === 'object') {
                        this.objectUnEscape(value);
                    } else if (typeof value === 'string') {
                        obj[key] = this.htmlUnescape(value);
                    }
                }
            }
        }

        static sortAlphabetically(array, key) {
            array.sort(
                (a, b) => {
                    return (!!a[key]) ? a[key].toLowerCase().localeCompare(b[key].toLowerCase()) : a[key];
                }
            );

        }

        //Returns the date with time set to 23:59:59 in local tz
        static getLocalEndTimeInUTC(dt: Date): Number {
            if (!dt) {
                return null;
            }
            return new Date(dt).setHours(23, 59, 59, 999);
        }

        //Returns the date with time set to 00:00:00 in local tz
        static getLocalStartTimeInUTC(dt: Date): Number {
            if (!dt) {
                return null;
            }
            return new Date(dt).setHours(0, 0, 0, 0);
        }

        //Sets current tz date as the UTC date
        //Eg. Thu May 23 2019 05:35:52 GMT-0400 (Eastern Daylight Time) will turn into
        //    Thu May 23 2019 00:00:00 GMT
        static getUTCTime(dt: Date): Number {
            if (!dt) {
                return null;
            }
            return Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate());
        }

        //Sets UTC date as the current tz date
        //Eg. Thu May 23 2019 03:35:52 GMT will turn into
        //    Thu May 23 2019 00:00:00 GMT-0400 (Eastern Daylight Time)
        static getNonUTCDate(milli): Date {
            if (!milli) {
                return null;
            }
            const dd = new Date(milli);
            return new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate());
        }

        //Get Non- UTC time only
        //Eg. (isMeridiem : true ) 02:32 pm
        //    (isMeridiem : false) 14:32
        static getNonUTCTime(milli, isMeridiem : boolean = true) {
            const formatValue = isMeridiem ? 'hh:mm a' : 'HH:mm';
            return moment(Util.getNonUTCDateTime(parseFloat(milli))).format(formatValue);
        }

        //Sets current tz date as the UTC date
        //Eg. Thu May 23 2019 05:35:52 GMT-0400 (Eastern Daylight Time) will turn into
        //    Thu May 23 2019 05:35:52 GMT
        static getUTCDateTime(dt: Date): Number {
            if (!dt) {
                return null;
            }
            return Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate(), dt.getHours(),dt.getMinutes(),dt.getSeconds());
        }

        //Sets UTC date as the current tz date
        //Eg. Thu May 23 2019 03:35:52 GMT will turn into
        //    Thu May 23 2019 03:35:52 GMT-0400 (Eastern Daylight Time)
        static getNonUTCDateTime(milli): Date {
            if (!milli) {
                return null;
            }
            const dd = new Date(milli);
            return new Date(dd.getUTCFullYear(), dd.getUTCMonth(), dd.getUTCDate(), dd.getUTCHours(), dd.getUTCMinutes(), dd.getUTCSeconds());
        }

        static getRGBToHex (color) {
            const colorCodeToHex = (rgb) => {
                let hex = Number(rgb).toString(16);
                if (hex.length < 2) {
                    hex = "0" + hex;
                }
                return hex;
            };
            const clr = color.split(',');
            const red = colorCodeToHex(parseInt(clr[0].substring(4)));
            const green = colorCodeToHex(parseInt(clr[1].trim()));
            const blue = colorCodeToHex(parseInt(clr[2].trim().substring(0, clr[2].trim().length - 1)));
            return "#" + red + green + blue;
        };

        static fixUTCDate(dt: Date): Number {
            // time zone offset in minutes * 60 seconds * 1000 miliseconcs
            return new Date(dt.getTime() + dt.getTimezoneOffset() * 60 * 1000).getTime();
        }

        static fixNonUTCDate(dt: Date): Date {
            return new Date(dt.getTime() - new Date().getTimezoneOffset() * 60 * 1000);
        }

        static isLocalStorageNameSupported() {

            const testKey = 'test',
                storage = window.sessionStorage,
                localStorage = window.localStorage;
            try {
                localStorage.setItem(testKey, '1')
                storage.setItem(testKey, '1');
                storage.removeItem(testKey);
                localStorage.removeItem(testKey);

                if (!window.indexedDB) {
                    return false;
                }

                return true;
            } catch (error) {
                return false;
            }
        }

        static getQuestions() {
            return [
                { id: '1', name: 'The city you were born in?' },
                { id: '2', name: 'The name of your first born child?' },
                { id: '3', name: 'The name of your first pet?' },
                { id: '4', name: "Your father's middle name?" },
                { id: '5', name: 'The make of your first car?' }];
        }

        static _arrayBufferToBase64(buffer) {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0;i < len;i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
        }


        static getServiceList() {
            return [
                "Counseling",
                "Math Fluency",
                "Math Problem Solving",
                "Medical",
                "Occupational Therapy",
                "Reading Comprehension",
                "Reading Fluency",
                "Speech Language Therapy",
                "Social Skills Group",
                "Teaching",
                "Writing", "Other",
            ];
        }

        static getGroupList() {
            return [
                "0-10",
                "10-25",
                "25-50",
                "50-75",
                "75-100",
                "100+"
            ];
        }

        static formatAMPM(date) {
            let hours = date.getHours();
            let minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes;
            const strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        }

        static clone(obj) {
            if (null == obj || "object" != typeof obj) return obj;
            const copy = obj.constructor();
            for (const attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
            }
            return copy;
        }

        static getGradeList() {
            return [
                { id: '1', name: '1' },
                { id: '2', name: '2' },
                { id: '3', name: '3' },
                { id: '4', name: '4' },
                { id: '5', name: '5' },
                { id: '6', name: '6' },
                { id: '7', name: '7' },
                { id: '8', name: '8' },
                { id: '9', name: '9' },
                { id: '10', name: '10' },
                { id: '11', name: '11' },
                { id: '12', name: '12' }
            ];

        }

        static getMonthList() {
            return [
                { id: '00', name: 'January' },
                { id: '01', name: 'February' },
                { id: '02', name: 'March' },
                { id: '03', name: 'April' },
                { id: '04', name: 'May' },
                { id: '05', name: 'June' },
                { id: '06', name: 'July' },
                { id: '07', name: 'August' },
                { id: '08', name: 'September' },
                { id: '09', name: 'October' },
                { id: '10', name: 'November' },
                { id: '11', name: 'December' },
            ];

        }

        static getYearsList(monthCnt?, dob?) {
            let monthCount = 100;
            if (!!monthCnt)
                monthCount = monthCnt;
            const years = [];
            const currentYear = new Date().getFullYear();

            let startYear = currentYear;

            while (startYear >= (currentYear - monthCount)) {
                years.push({ id: startYear, name: startYear });
                startYear--;
            }


            return years;
        }

        static getDaysFromMonth(month, year?) {
            if (year) {
                if (month == '01' && (year % 4 > 0)) {
                    return 28;
                }
            }
            return (month == '01' ? 29 : (month == '03' || month == '05' || month == '08' || month == '10' ? 30 : 31));
        }

        static getDaysList(limit?) {
            const days = [];
            let i = 1;
            limit = limit ? limit : 31;
            while (i <= limit) {
                days.push({ id: i, name: i });
                i++;
            }
            return days;
        }


        static getProfessionList() {
            return [
                "Parent/Guardian",
                "Family Member",
                "Friend",
                "Audiologist",
                "Counselor",
                "Head of School",
                "Learning Specialist",
                "Neuropsychologist",
                "Occupational Therapist",
                "Ophthalmologist",
                "Physical Therapist",
                "Principal",
                "Psychologist",
                "Reading Specialist",
                "Social Worker",
                "Speech Language Therapist",
                "Student Advisor",
                "Teacher",
                "Other"
            ].sort();
        }

        static getProjectTypes() {
            return Util.projectTypes.sort(
                (a, b) => {
                    return (!!a.projectType) ? a.projectType.toLowerCase().localeCompare(b.projectType.toLowerCase()) : a.projectType;
                }
            );
        }
        static getServiceLocations() {
            Util.serviceLocations = [{ id: 1, name: "Classroom" },
            { id: 2, name: "Pull-out" }, { id: 3, name: "Substantially separate" },
            { id: 4, name: "Other" }];
            return Util.serviceLocations.sort(
                (a, b) => {
                    return (!!a.name) ? a.name.toLowerCase().localeCompare(b.name.toLowerCase()) : a.name;
                }
            );
        }

        static setProjectTypes(projectTypes) {
            Util.projectTypes = projectTypes;
        }

        static setServiceLocations(serviceLocations) {
            Util.serviceLocations = serviceLocations;
        }

        static getServiceLocationNames(locationId) {

            const arr = Util.getServiceLocations();

            for (let i = 0;i < arr.length;i++) {
                if (arr[i].id == locationId) {
                    return arr[i].name;
                }

            }
            return "";
        }

        static getServiceLocationId(location) {

            const arr = Util.getServiceLocations();

            for (let i = 0;i < arr.length;i++) {
                if (arr[i].name.toLowerCase() == location.toLowerCase()) {
                    return arr[i].id;
                }

            }
            return "";
        }

        static getCityList() {
            return [
                { id: '1', name: 'Abingdon' },
                { id: '2', name: 'Acton' },
                { id: '3', name: 'Akron' },
                { id: '4', name: 'Alameda' },
                { id: '5', name: 'Albany' },
                { id: '6', name: 'Albany' },
                { id: '7', name: 'Alexandria' },
                { id: '8', name: 'Algonquin' },
                { id: '9', name: 'Alliance' },
                { id: '10', name: 'American Canyon' },
                { id: '11', name: 'Amherst' },
                { id: '12', name: 'Ann Arbor' },
                { id: '13', name: 'Antioch' },
                { id: '14', name: 'Arlington' },
                { id: '15', name: 'Arroyo Grande' },
                { id: '16', name: 'Arvada' },
                { id: '17', name: 'Asheville' },
                { id: '18', name: 'Ashland' },
                { id: '19', name: 'Aspen' },
                { id: '20', name: 'Atascadero' },
                { id: '21', name: 'Athens' },
                { id: '22', name: 'Atlanta' },
                { id: '23', name: 'Auburn' },
                { id: '24', name: 'Austin' },
                { id: '25', name: 'Ayer' },
                { id: '26', name: 'Babylon' },
                { id: '27', name: 'Bainbridge Island' },
                { id: '28', name: 'Barnstable' },
                { id: '29', name: 'Beaverton' },
                { id: '30', name: 'Bedford' },
                { id: '31', name: 'Belfast' },
                { id: '32', name: 'Bellevue' },
                { id: '33', name: 'Bellingham' },
                { id: '34', name: 'Belmar' },
                { id: '35', name: 'Belmont' },
                { id: '36', name: 'Belvedere' },
                { id: '37', name: 'Benicia' },
                { id: '38', name: 'Berea' },
                { id: '39', name: 'Berkeley' },
                { id: '40', name: 'Beverly Hills' },
                { id: '41', name: 'Binghamton' },
                { id: '42', name: 'Blacksburg' },
                { id: '43', name: 'Bloomington' },
                { id: '44', name: 'Boston' },
                { id: '45', name: 'Bothell' },
                { id: '46', name: 'Boulder' },
                { id: '47', name: 'Bowie' },
                { id: '48', name: 'Boynton Beach' },
                { id: '49', name: 'Bozeman' },
                { id: '50', name: 'Branford' },
                { id: '51', name: 'Breckenridge' },
                { id: '52', name: 'Bridgeport' },
                { id: '53', name: 'Brighton' },
                { id: '54', name: 'Brookfield' },
                { id: '55', name: 'Brookhaven' },
                { id: '56', name: 'Brookline' },
                { id: '57', name: 'Bryan' },
                { id: '58', name: 'Burlingame' },
                { id: '59', name: 'Burlington' },
                { id: '60', name: 'Calistoga' },
                { id: '61', name: 'Cambridge' },
                { id: '62', name: 'Carbondale' },
                { id: '63', name: 'Carmel' },
                { id: '64', name: 'Carpentaria' },
                { id: '65', name: 'Carrboro' },
                { id: '66', name: 'Carver' },
                { id: '67', name: 'Cary' },
                { id: '68', name: 'Champaign' },
                { id: '69', name: 'Chandler' },
                { id: '70', name: 'Chapel Hill' },
                { id: '71', name: 'Charleston' },
                { id: '72', name: 'Charlotte' },
                { id: '73', name: 'Charlottesville' },
                { id: '74', name: 'Chatham' },
                { id: '75', name: 'Chattanooga' },
                { id: '76', name: 'Chelmsford' },
                { id: '77', name: 'Chevy Chase' },
                { id: '78', name: 'Chicago' },
                { id: '79', name: 'Chula Vista' },
                { id: '80', name: 'Cimarron' },
                { id: '81', name: 'Cincinnati' },
                { id: '82', name: 'Clayton' },
                { id: '83', name: 'Clermont' },
                { id: '84', name: 'Cleveland' },
                { id: '85', name: 'Clifton' },
                { id: '86', name: 'Cloverdale' },
                { id: '87', name: 'College Park' },
                { id: '88', name: 'College Station' },
                { id: '89', name: 'Columbia' },
                { id: '90', name: 'Columbia' },
                { id: '91', name: 'Concord' },
                { id: '92', name: 'Concord' },
                { id: '93', name: 'Cookeville' },
                { id: '94', name: 'Cooperstown' },
                { id: '95', name: 'Coppell' },
                { id: '96', name: 'Cortland' },
                { id: '97', name: 'Corvallis' },
                { id: '98', name: 'Coupeville' },
                { id: '99', name: 'Cranberry Township' },
                { id: '101', name: 'Creve Coeur' },
                { id: '102', name: 'Croton on Hudson' },
                { id: '103', name: 'Culver City' },
                { id: '104', name: 'Cupertino' },
                { id: '105', name: 'Cutler Bay' },
                { id: '106', name: 'Dallas' },
                { id: '107', name: 'Danville' },
                { id: '108', name: 'Davie' },
                { id: '109', name: 'Davis' },
                { id: '100', name: 'Dearborn' },
                { id: '101', name: 'Decatur' },
                { id: '102', name: 'Decorah' },
                { id: '103', name: 'Dedham' },
                { id: '104', name: 'Del Mar' },
                { id: '105', name: 'Delray Beach' },
                { id: '106', name: 'Denton' },
                { id: '107', name: 'Denver' },
                { id: '108', name: 'DeWitt' },
                { id: '109', name: 'Dixon' },
                { id: '110', name: 'Dobbs Ferry' },
                { id: '111', name: 'Dryden' },
                { id: '112', name: 'Duarte' },
                { id: '113', name: 'Dublin' },
                { id: '114', name: 'Dubuque' },
                { id: '115', name: 'Duluth' },
                { id: '116', name: 'Dumfries' },
                { id: '117', name: 'Durango' },
                { id: '118', name: 'Durham' },
                { id: '119', name: 'East Palo Alto' },
                { id: '120', name: 'Eastchester' },
                { id: '121', name: 'Edina' },
                { id: '122', name: 'Edinburg' },
                { id: '123', name: 'Edmonds' },
                { id: '124', name: 'Edwardsville' },
                { id: '125', name: 'El Cerrito' },
                { id: '126', name: 'El Paso' },
                { id: '127', name: 'Elmhurst' },
                { id: '128', name: 'Emeryville' },
                { id: '129', name: 'Encinitas' },
                { id: '130', name: 'Essex' },
                { id: '131', name: 'Eugene' },
                { id: '132', name: 'Everett' },
                { id: '133', name: 'Fairbanks North Star Borough' },
                { id: '134', name: 'Fairfax' },
                { id: '135', name: 'Fairfield' },
                { id: '136', name: 'Fairfield' },
                { id: '137', name: 'Fairmont' },
                { id: '138', name: 'Falls Church' },
                { id: '139', name: 'Falls' },
                { id: '140', name: 'Falmouth' },
                { id: '141', name: 'Fayetteville' },
                { id: '142', name: 'Ferndale' },
                { id: '143', name: 'Fitchburg' },
                { id: '144', name: 'Flagstaff' },
                { id: '145', name: 'Flint' },
                { id: '146', name: 'Forest Hills' },
                { id: '147', name: 'Fort Collins' },
                { id: '148', name: 'Fort Lauderdale' },
                { id: '149', name: 'Fort Wayne' },
                { id: '150', name: 'Foster City' },
                { id: '151', name: 'Frankfort' },
                { id: '152', name: 'Franklin' },
                { id: '153', name: 'Fremont' },
                { id: '154', name: 'Fullerton' },
                { id: '155', name: 'Gainesville' },
                { id: '156', name: 'Gaithersburg' },
                { id: '157', name: 'Gatlinburg' },
                { id: '158', name: 'Geneva' },
                { id: '159', name: 'Georgetown' },
                { id: '160', name: 'Glendale' },
                { id: '161', name: 'Grand Forks' },
                { id: '162', name: 'Grand Rapids' },
                { id: '163', name: 'Grapevine' },
                { id: '164', name: 'Greenbelt' },
                { id: '165', name: 'Greenville' },
                { id: '166', name: 'Groton' },
                { id: '167', name: 'Hailey' },
                { id: '168', name: 'Hamilton' },
                { id: '169', name: 'Harrisonburg' },
                { id: '170', name: 'Hayward' },
                { id: '171', name: 'Helena' },
                { id: '172', name: 'Henderson' },
                { id: '173', name: 'Hermosa Beach' },
                { id: '174', name: 'Hillsboro' },
                { id: '175', name: 'Hillsborough' },
                { id: '176', name: 'Houston' },
                { id: '177', name: 'Howard' },
                { id: '178', name: 'Hunter' },
                { id: '179', name: 'Huntington' },
                { id: '180', name: 'Huntsville' },
                { id: '181', name: 'Hyattsville' },
                { id: '182', name: 'Inglewood' },
                { id: '183', name: 'Iowa City' },
                { id: '184', name: 'Ipswich' },
                { id: '185', name: 'Irvine' },
                { id: '186', name: 'Irving' },
                { id: '187', name: 'Issaquah' },
                { id: '178', name: 'Ithaca' },
                { id: '189', name: 'Juneau' },
                { id: '190', name: 'Kansas City' },
                { id: '191', name: 'Keene' },
                { id: '192', name: 'Key West' },
                { id: '193', name: 'Kingston' },
                { id: '194', name: 'Kirkland' },
                { id: '195', name: 'Kirkwood' },
                { id: '196', name: 'Knoxville' },
                { id: '197', name: 'Kodiak' },
                { id: '198', name: 'La Mirada' },
                { id: '199', name: 'Lacey' },
                { id: '200', name: 'Lafayette' },
                { id: '201', name: 'Lake Elsinore' },
                { id: '202', name: 'Lake Forest' },
                { id: '203', name: 'Lake Oswego' },
                { id: '204', name: 'Lake Worth' },
                { id: '205', name: 'Lakewood' },
                { id: '206', name: 'Larchmont' },
                { id: '207', name: 'Las Cruces' },
                { id: '208', name: 'Las Vegas' },
                { id: '209', name: 'Lawrence' },
                { id: '210', name: 'Lees Summit' },
                { id: '211', name: 'Lewes' },
                { id: '212', name: 'Lexington' },
                { id: '213', name: 'Lincoln City' },
                { id: '214', name: 'Livermore' },
                { id: '215', name: 'Lomita' },
                { id: '216', name: 'Los Altos Hills' },
                { id: '217', name: 'Los Gatos' },
                { id: '218', name: 'Loveland' },
                { id: '219', name: 'Lowell' },
                { id: '220', name: 'Lower Southampton' },
                { id: '221', name: 'Lynchburg' },
                { id: '222', name: 'Lynnwood' },
                { id: '223', name: 'Madison' },
                { id: '224', name: 'Mahtomedi' },
                { id: '225', name: 'Maitland' },
                { id: '226', name: 'Manitou Spring' },
                { id: '227', name: 'Mankato' },
                { id: '228', name: 'Maplewood' },
                { id: '229', name: 'Marathon' },
                { id: '230', name: 'Marlboro' },
                { id: '231', name: 'Marshfield' },
                { id: '232', name: 'Martinez' },
                { id: '233', name: 'McMinnville' },
                { id: '234', name: 'Meadville' },
                { id: '235', name: 'Medford' },
                { id: '236', name: 'Menlo Park' },
                { id: '237', name: 'Merced' },
                { id: '238', name: 'Mercer Island' },
                { id: '239', name: 'Miami Gardens' },
                { id: '240', name: 'Miami' },
                { id: '241', name: 'Middletown' },
                { id: '242', name: 'Mill Valley' },
                { id: '243', name: 'Millbrae' },
                { id: '244', name: 'Milpitas' },
                { id: '245', name: 'Milton' },
                { id: '246', name: 'Milwaukee' },
                { id: '247', name: 'Milwaukie' },
                { id: '248', name: 'Minneapolis' },
                { id: '249', name: 'Mission' },
                { id: '250', name: 'Missoula' },
                { id: '251', name: 'Monterey' },
                { id: '252', name: 'Montgomery Township' },
                { id: '253', name: 'Moorpark' },
                { id: '254', name: 'Moraga' },
                { id: '255', name: 'Morro Bay' },
                { id: '256', name: 'Mount Kisco' },
                { id: '257', name: 'Mountain View' },
                { id: '258', name: 'Mt. Lebanon' },
                { id: '259', name: 'Muncie' },
                { id: '260', name: 'Murrieta' },
                { id: '261', name: 'Nantucket' },
                { id: '262', name: 'Napa' },
                { id: '263', name: 'Narberth' },
                { id: '264', name: 'Nashua' },
                { id: '265', name: 'Nashville' },
                { id: '266', name: 'Natick' },
                { id: '267', name: 'National City' },
                { id: '268', name: 'Nether Providence' },
                { id: '269', name: 'New Brunswick' },
                { id: '270', name: 'New Castle' },
                { id: '271', name: 'New Haven' },
                { id: '272', name: 'New London' },
                { id: '273', name: 'New Orleans' },
                { id: '274', name: 'New Rochelle' },
                { id: '275', name: 'New York' },
                { id: '276', name: 'Newark' },
                { id: '277', name: 'Newburyport' },
                { id: '278', name: 'Norfolk' },
                { id: '279', name: 'Norman' },
                { id: '280', name: 'North Andover' },
                { id: '281', name: 'North Castle' },
                { id: '282', name: 'North Hempstead' },
                { id: '283', name: 'North Las Vegas ' },
                { id: '284', name: 'North Liberty' },
                { id: '285', name: 'North Little Rock' },
                { id: '286', name: 'North Miami' },
                { id: '287', name: 'Northampton' },
                { id: '288', name: 'Northbrook' },
                { id: '289', name: 'Novato' },
                { id: '290', name: 'Oak Harbor' },
                { id: '291', name: 'Oak Park' },
                { id: '292', name: 'Oak Ridge' },
                { id: '293', name: 'Oakdale' },
                { id: '294', name: 'Oakland' },
                { id: '295', name: 'Oakley' },
                { id: '296', name: 'Oberlin' },
                { id: '297', name: 'Ogdensburg' },
                { id: '298', name: 'Olivette' },
                { id: '299', name: 'Olympia' },
                { id: '300', name: 'Omaha' },
                { id: '301', name: 'Orinda' },
                { id: '302', name: 'Orlando' },
                { id: '303', name: 'Ormond Beach' },
                { id: '304', name: 'Oshkosh' },
                { id: '305', name: 'Oswego' },
                { id: '306', name: 'Oxford' },
                { id: '307', name: 'Pacifica' },
                { id: '308', name: 'Palm Bay' },
                { id: '309', name: 'Palm Springs' },
                { id: '310', name: 'Palmdale' },
                { id: '311', name: 'Palo Alto' },
                { id: '312', name: 'Park City' },
                { id: '313', name: 'Parlier' },
                { id: '314', name: 'Peekskill' },
                { id: '315', name: 'Penndel Borough' },
                { id: '316', name: 'Peoria' },
                { id: '317', name: 'Philadelphia' },
                { id: '318', name: 'Phoenix' },
                { id: '319', name: 'Pinecrest' },
                { id: '320', name: 'Pittsburg' },
                { id: '321', name: 'Pittsburgh' },
                { id: '322', name: 'Plano' },
                { id: '323', name: 'Plantation' },
                { id: '324', name: 'Port Townsend' },
                { id: '325', name: 'Portland' },
                { id: '326', name: 'Portsmouth' },
                { id: '327', name: 'Pound Ridge' },
                { id: '328', name: 'Prairie Village' },
                { id: '329', name: 'Providence' },
                { id: '330', name: 'Quincy' },
                { id: '331', name: 'Radnor' },
                { id: '332', name: 'Raleigh' },
                { id: '333', name: 'Rancho Cucamonga' },
                { id: '334', name: 'Red Hook' },
                { id: '335', name: 'Redmond' },
                { id: '336', name: 'Redwood City' },
                { id: '337', name: 'Renton' },
                { id: '338', name: 'Richardson' },
                { id: '339', name: 'Richmond' },
                { id: '340', name: 'Ridgefield' },
                { id: '341', name: 'Riverside' },
                { id: '342', name: 'Roanoke' },
                { id: '343', name: 'Rochester' },
                { id: '344', name: 'Rock Island' },
                { id: '345', name: 'Rockford' },
                { id: '346', name: 'Rockville' },
                { id: '347', name: 'Rolling Hills Estates' },
                { id: '348', name: 'Rolling Hills' },
                { id: '349', name: 'Rosendale' },
                { id: '350', name: 'Roseville' },
                { id: '351', name: 'Rye' },
                { id: '352', name: 'Sacramento' },
                { id: '353', name: 'Saint George' },
                { id: '354', name: 'Saint Helena' },
                { id: '355', name: 'Saint Louis' },
                { id: '356', name: 'Saint Paul' },
                { id: '357', name: 'Salem' },
                { id: '358', name: 'Salinas' },
                { id: '359', name: 'Salisbury' },
                { id: '360', name: 'Salt Lake City' },
                { id: '361', name: 'San Anselmo' },
                { id: '362', name: 'San Antonio' },
                { id: '363', name: 'San Bruno' },
                { id: '364', name: 'San Carlos' },
                { id: '365', name: 'San Clemente' },
                { id: '366', name: 'San Diego' },
                { id: '367', name: 'San Francisco' },
                { id: '368', name: 'San Jose' },
                { id: '369', name: 'San Leandro' },
                { id: '370', name: 'San Luis Obispo' },
                { id: '371', name: 'San Mateo' },
                { id: '372', name: 'San Pablo' },
                { id: '373', name: 'San Rafael' },
                { id: '374', name: 'San Ramon' },
                { id: '375', name: 'Santa Ana' },
                { id: '376', name: 'Santa Barbara' },
                { id: '377', name: 'Santa Clara' },
                { id: '378', name: 'Santa Clarita' },
                { id: '379', name: 'Santa Cruz' },
                { id: '380', name: 'Santa Fe' },
                { id: '381', name: 'Santa Monica' },
                { id: '382', name: 'Santa Rosa' },
                { id: '383', name: 'Sarasota' },
                { id: '384', name: 'Saratoga Springs' },
                { id: '385', name: 'Saugerties' },
                { id: '386', name: 'Savannah' },
                { id: '387', name: 'Seaside' },
                { id: '388', name: 'SeaTac' },
                { id: '389', name: 'Seattle' },
                { id: '390', name: 'Sequim' },
                { id: '391', name: 'Shoreline' },
                { id: '392', name: 'Sierra Madre' },
                { id: '393', name: 'Silver City' },
                { id: '394', name: 'Sioux Falls' },
                { id: '395', name: 'Sitka' },
                { id: '396', name: 'Solana Beach' },
                { id: '397', name: 'Somers' },
                { id: '398', name: 'Sonoma City' },
                { id: '399', name: 'South Bend' },
                { id: '400', name: 'South Burlington' },
                { id: '401', name: 'South Daytona' },
                { id: '402', name: 'South Gate' },
                { id: '403', name: 'South Miami' },
                { id: '404', name: 'South Portland' },
                { id: '405', name: 'Spartanburg' },
                { id: '406', name: 'Spokane' },
                { id: '407', name: 'Springfield' },
                { id: '408', name: 'Stamford' },
                { id: '409', name: 'Staunton' },
                { id: '410', name: 'Stonington' },
                { id: '411', name: 'Sumter' },
                { id: '412', name: 'Sunnyvale' },
                { id: '413', name: 'Syracuse' },
                { id: '414', name: 'Tacoma' },
                { id: '415', name: 'Takoma Park' },
                { id: '416', name: 'Tallahassee' },
                { id: '417', name: 'Tamarac' },
                { id: '418', name: 'Tampa' },
                { id: '419', name: 'Taos' },
                { id: '420', name: 'Tarrytown' },
                { id: '421', name: 'Temecula' },
                { id: '422', name: 'Tempe' },
                { id: '423', name: 'Tewksbury' },
                { id: '424', name: 'Texarkana' },
                { id: '425', name: 'Tiburon' },
                { id: '426', name: 'Tracy' },
                { id: '427', name: 'Traverse City' },
                { id: '428', name: 'Tuckahoe' },
                { id: '429', name: 'Tucson' },
                { id: '430', name: 'Tulsa' },
                { id: '431', name: 'Tumwater' },
                { id: '432', name: 'Tyngsborough' },
                { id: '433', name: 'Union City' },
                { id: '434', name: 'University City' },
                { id: '435', name: 'Urbana' },
                { id: '436', name: 'Vacaville' },
                { id: '437', name: 'Vallejo' },
                { id: '438', name: 'Venice' },
                { id: '439', name: 'Vernon' },
                { id: '440', name: 'Victor' },
                { id: '441', name: 'Virginia' },
                { id: '442', name: 'Visalia' },
                { id: '443', name: 'Vista' },
                { id: '444', name: 'Walnut Creek' },
                { id: '445', name: 'Waltham' },
                { id: '446', name: 'Washington' },
                { id: '447', name: 'Wellesley' },
                { id: '448', name: 'West Chester' },
                { id: '449', name: 'West Palm Beach' },
                { id: '450', name: 'West Sacramento' },
                { id: '451', name: 'West Windsor' },
                { id: '452', name: 'Westminster' },
                { id: '453', name: 'Williamstown' },
                { id: '454', name: 'Willits' },
                { id: '455', name: 'Wilton' },
                { id: '456', name: 'Winchester' },
                { id: '457', name: 'Windsor' },
                { id: '458', name: 'Windsor' },
                { id: '459', name: 'Winston-Salem' },
                { id: '460', name: 'Wolfeboro' },
                { id: '461', name: 'Woodbury' },
                { id: '462', name: 'Woodside' },
                { id: '463', name: 'Woodstock' },
                { id: '464', name: 'Worcester' },
                { id: '465', name: 'Yarmouth' },
                { id: '466', name: 'Yonkers' },
                { id: '467', name: 'York' },
                { id: '468', name: 'Youngstown' },
                { id: '469', name: 'Yountville' },
            ];
        }

        static getDocumentTypeList(orgName?: string) {
            let arr = [
                "Addendum",
                "Care Journal",
                "Conferences",
                "Draft Report",
                "Evaluations",
                "Grades",
                "IEP",
                "IEP Meetings",
                "Intake Questionnaire",
                "Medical Reports",
                "Meeting Notes",
                "Notes",
                "Photo",
                "Progress Notes",
                "Recommendations",
                "Report Card",
                "Reports",
                "School Observation",
                "Scoring",
                "Session Notes",
                "Test Results",
                "Therapy Notes",
                "Transition Plan",
                "Transition Report",
                "Treatment Plans",
                "Treatment Summary"
            ];

            if (!!orgName) {
                let orgMap = Util.orgTypeMaps.find(orgNameMap => !!orgNameMap.orgs.find(oName => oName == orgName));
                if (!!orgMap) {
                    if (!!Util.orgDocTypes[orgMap.name]) {
                        arr = arr.concat(Util.orgDocTypes[orgMap.name]);
                    }
                }
            }

            arr.sort();
            arr[arr.length] = "Other";
            return arr;
        }

        static getProviderTypeList(orgName?: string) {
            let arr = [
                'Advocate',
                'Assistant',
                'Audiologist',
                'Care Attendant',
                'Care Recipient',
                'Case Manager',
                'Clinical Assistant',
                'Consultant',
                'Counselor',
                'Doctor',
                'Family Specialist',
                'Head of School',
                'Home Care Attendant',
                'Intake Coordinator',
                'Intensive Care Coordinator',
                'Lawyer',
                'Learning Specialist',
                'Neurologist',
                'Neuropsychologist',
                'Neuropsychologist (Post-doc)',
                'Nurse',
                'Occupational Therapist',
                'Office Manager',
                'Ophthalmologist',
                'Parent/Guardian',
                'Partner',
                'Pediatrician',
                'Physical Therapist',
                'Physician',
                'Primary Caregiver',
                'Principal',
                'Psychologist',
                'Psychology Assistant',
                'Psychometrician',
                'Reading Specialist',
                'Resource Specialist',
                'School Counselor',
                'Social Worker',
                'Speech Language Therapist',
                'Student Advisor',
                'Teacher',
                'Trainee',
                'Transition Specialist',
                'Tutor',
            ];

            if (!!orgName) {
                let orgMap = Util.orgTypeMaps.find(orgNameMap => !!orgNameMap.orgs.find(oName => oName == orgName));
                if (!!orgMap) {
                    if (!!Util.orgAuthorTypes[orgMap.name]) {
                        arr = arr.concat(Util.orgAuthorTypes[orgMap.name]);
                    }
                }
            }

            arr.sort();
            arr[arr.length] = "Other";
            return arr;

        };

        static orgAuthorTypes = {
            "OSA": [
                'Case Manager/Social Worker',
                'Family Member',
                'Oasis Senior Advisor',
                'Service Provider'
            ]
        }

        static orgDocTypes = {
            "OSA": [
                'Power of Attorney (General/Financial)',
                'Living Will (aka Care Directive)',
                'Do Not Resuscitate',
                'Medication List',
                'Discharge Instructions',
                'Care Notes',
                'Power of Attorney (Special)',
                'Power of Attorney (Healthcare)'
            ]
        }

        static orgTypeMaps = [{
            name: 'OSA',
            orgs: [
                'eCare Vault',
                'OSA Demo',
                'Oasis Senior Advisors',
                'Jeavio'
            ]
        }]


        static getCategoryList() {
            const arr = [
                "Academics",
                "Arts/Creative",
                "Community Work",
                "Life Skills",
                "Vacation",
                "Summer Activities",
                "Memories",
                "Sports",
                "Vacation",
                "Summer Activities",
                "Memories"
            ].sort();

            arr[arr.length] = "Miscellaneous";
            return arr;

        };

        static getGenderList() {
            return [
                { id: "M", name: 'Male' },
                { id: "F", name: 'Female' },
                { id: "O", name: 'Non-identified' },
            ];
        }

        static getOrganizationTypeList() {
            return [
                // { id: "1", name: 'Health' },
                { id: "1", name: 'School' },
                { id: "2", name: 'Private Practice' }
            ];
        }

        static getTextConfigForSharePopup() {
            return {
                document: {
                    confirmTitle: "Confirm Sharing",
                    uploadFlow: {
                        title: "Upload & Share with Team Members",
                        responsiveTitle: "Upload & Share",
                        topPanelTitle: "Share the Document with Team Members",
                        bottomPanelTitle: "Team Members with access to this Document"
                    },
                    shareFlow: {
                        title: "Share Document with Team Members",
                        responsiveTitle: "Share Document",
                        topPanelTitle: "Share the Document with Team Members",
                        bottomPanelTitle: "Team Members with access to this Document"
                    },
                    msgVars: {
                        var1: "Sharing",
                        var2: "share with",
                        var3: "access to this Document"
                    }
                },
                discussion: {
                    confirmTitle: "Confirm Participants",
                    title: "Add Participants to Discussion",
                    responsiveTitle: "Add Participants",
                    topPanelTitle: "Choose Team Members",
                    bottomPanelTitle: "Participating Team Members",
                    msgVars: {
                        var1: "Participation",
                        var2: "add",
                        var3: "to participate"
                    }
                },
                form: {
                    confirmTitle: "Confirm Sharing",
                    title: "Share or Assign Form",
                    responsiveTitle: "Share or Assign Form",
                    topPanelTitle: "Choose Team Members",
                    bottomPanelTitle: "Team Members with Access",
                    msgVars: {
                        var1: "Sharing",
                        var2: "share with",
                        var3: "access to this Form"
                    }
                },
                service: {
                    confirmTitle: "Confirm Sharing",
                    title: "Share Service Assignment",
                    responsiveTitle: "Share Service",
                    topPanelTitle: "Choose Team Members",
                    bottomPanelTitle: "Team Members with Access",
                    msgVars: {
                        var1: "Sharing",
                        var2: "share with",
                        var3: "access to this Service"
                    }
                },
                note: {
                    confirmTitle: "Confirm Sharing",
                    title: "Share Service Note",
                    responsiveTitle: "Add Participants",
                    topPanelTitle: "Choose Team Members",
                    bottomPanelTitle: "Team Members with Access",
                    msgVars: {
                        var1: "Sharing",
                        var2: "share with",
                        var3: "access to this Note"
                    }
                }
            }
        }

        static getTextsForToggleTeamFreeze() {
            return {
                freeze: {
                    title: "Confirm Team Freeze",
                    message: "To make sure you want to freeze ${text1} Team please type ${text2} in the box below.",
                    errMessage: "Please type ${refText} exactly - including case.",
                    btnText: "Freeze Team"
                },
                unfreeze: {
                    title: "Request Team Thaw",
                    message: "Please describe your need to unfreeze ${text1}.",
                    errMessage: "500 Characters Max",
                    btnText: "Request Thaw"
                }
            }
        }

        static getStateList() {
            return [
                { name: 'AL', id: '1' },
                { name: 'AK', id: '2' },
                { name: 'AZ', id: '3' },
                { name: 'AR', id: '4' },
                { name: 'CA', id: '5' },
                { name: 'CO', id: '6' },
                { name: 'CT', id: '7' },
                { name: 'DE', id: '8' },
                { name: 'FL', id: '9' },
                { name: 'GA', id: '10' },
                { name: 'HI', id: '11' },
                { name: 'ID', id: '12' },
                { name: 'IL', id: '13' },
                { name: 'IN', id: '14' },
                { name: 'IA', id: '15' },
                { name: 'KS', id: '16' },
                { name: 'KY', id: '17' },
                { name: 'LA', id: '18' },
                { name: 'ME', id: '19' },
                { name: 'MD', id: '20' },
                { name: 'MA', id: '21' },
                { name: 'MI', id: '22' },
                { name: 'MN', id: '23' },
                { name: 'MS', id: '24' },
                { name: 'MO', id: '25' },
                { name: 'MT', id: '26' },
                { name: 'NE', id: '27' },
                { name: 'NV', id: '28' },
                { name: 'NH', id: '29' },
                { name: 'NJ', id: '30' },
                { name: 'NM', id: '31' },
                { name: 'NY', id: '32' },
                { name: 'NC', id: '33' },
                { name: 'ND', id: '34' },
                { name: 'OH', id: '35' },
                { name: 'OK', id: '36' },
                { name: 'OR', id: '37' },
                { name: 'PA', id: '38' },
                { name: 'RI', id: '39' },
                { name: 'SC', id: '40' },
                { name: 'SD', id: '41' },
                { name: 'TN', id: '42' },
                { name: 'TX', id: '43' },
                { name: 'UT', id: '44' },
                { name: 'VT', id: '45' },
                { name: 'VA', id: '46' },
                { name: 'WA', id: '47' },
                { name: 'WV', id: '48' },
                { name: 'WI', id: '49' },
                { name: 'WY', id: '50' }];
        }

        static getNumberOfChildren() {
            return [
                { id: "1", name: '1' },
                { id: "2", name: '2' },
                { id: "3", name: '3' },
                { id: "4", name: '4' },
                { id: "5", name: '5' },
                { id: "6", name: '6' },
                { id: "7", name: '7' },
                { id: "8", name: '8' }
            ];
        }


        static getSetting() {
            return [
                { id: "Home", name: 'Home' },
                { id: "School", name: 'School' },
                { id: "Private practice", name: 'Private Practice' }
            ];
        }

        static getPeriod() {
            return [
                { id: "daily", name: 'Daily' },
                { id: "weekly", name: 'Weekly' },
                { id: "monthly", name: 'Monthly' },
                //{ id: "yearly", name: 'Yearly' }
            ];
        }

        static getSession() {
            return [
                { id: "1", name: '1' },
                { id: "2", name: '2' },
                { id: "3", name: '3' },
                { id: "4", name: '4' },
                { id: "5", name: '5' },
                { id: "6", name: '6' },
                { id: "7", name: '7' },
                { id: "8", name: '8' }
            ];
        }

        static getSessionDuration() {
            return [
                { id: "15", name: '15 Mins' },
                { id: "30", name: '30 Mins' },
                { id: "45", name: '45 Mins' },
                { id: "60", name: '1 Hr' },
                { id: "120", name: '2 Hrs' },
                { id: "240", name: '4 Hrs' }
            ];
        }

        static getFormat() {
            return [
                { id: "One on One", name: 'One-on-one' },
                { id: "Small Group", name: 'Small Group - Pullout' },
                { id: "Large Group", name: 'Large Group - General Classroom' }
            ];
        }

        static getRelationships() {
            return [
                { id: "mother", name: "Mother" },
                { id: "father", name: "Father" },
                { id: "guardian", name: "Guardian" }
            ];
        }

        static chunkArray(array, chunks) {
            if (chunks < 1) {
                return array;
            }

            let i, j, temparray = [];
            for (i = 0, j = array.length;i < j;i += chunks) {
                temparray.push(array.slice(i, i + chunks));
            }
            return temparray;
        }

        static days_between_dates(date1, date2) {

            // The number of milliseconds in one day
            const ONE_DAY = 1000 * 60 * 60 * 24

            // Convert both dates to milliseconds
            const date1_ms = date1.getTime()
            const date2_ms = date2.getTime()

            // Calculate the difference in milliseconds
            const difference_ms = Math.abs(date1_ms - date2_ms)

            // Convert back to days and return
            return Math.round(difference_ms / ONE_DAY)

        }

        static isMobile() {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                return true;
            }
            // iPadOS 13+ Safari reports a desktop "Macintosh" UA; treat a touch-capable
            // Mac as an iPad so tablets (iPad/iPad Air/Pro) are detected as mobile too.
            // maxTouchPoints > 0 (real Macs report 0, iPads report 5) reliably excludes
            // desktops/laptops while catching iPads and touch-emulated iPad presets.
            if ((/Macintosh/i.test(navigator.userAgent) || navigator.platform === 'MacIntel')
                && navigator.maxTouchPoints > 0) {
                return true;
            }
            return false;
        }

        // Returns true when the current device is running iOS/iPadOS.
        static isIOS() {
            return /iphone|ipad|ipod/i.test(navigator.userAgent)
                // iPadOS 13+ Safari reports as "Macintosh"; disambiguate via touch support.
                || (/Macintosh/i.test(navigator.userAgent) && typeof document !== 'undefined' && 'ontouchend' in document);
        }

        // Returns true when the current device is running Android.
        static isAndroid() {
            return /android/i.test(navigator.userAgent);
        }

        static moveToTop(source: any, item: any) {
            for (let i = 0;i < source.length;i++) {
                if (source[i].subjectId === item.subjectId) {
                    const a = source.splice(i, 1);   // removes the item
                    source.unshift(a[0]);         // adds it back to the beginning
                    break;

                }
            }
            return source;
        }

        static isValidEmail(email: string): boolean {
            const re = /^(?!.*\.\.)(?!.*\.@)[A-Za-z0-9._!#^+'~-]{1,64}@(?![^@]{49})[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
            return re.test(email);
        }

        static objHasVal(obj: any, val: any): boolean {
            let hasVal = false;
            Object.keys(obj).forEach(k => obj[k] == val && (hasVal = true));
            return hasVal;
        }

        static formatPhone(input, numberFormat) {
            if (!input) { return ''; }
            if (numberFormat == null) {
                numberFormat = "NATIONAL";
            }
            const odv = $(document.createElement("input")) as IPhoneInput;
            odv.intlTelInput();
            odv.val("+" + input);
            return odv.intlTelInput("getNumber");
        }

        static checkBrowser(type) {
            if (type.toLowerCase() == 'edge') {
                if (/Edge\/\d./i.test(navigator.userAgent)) {
                    return true;
                }
            }
            return false;
        }

        static getIEVersion() {
            let rv = -1;
            if (navigator.appName == 'Microsoft Internet Explorer') {
                const ua = navigator.userAgent;
                const re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                    rv = parseFloat(RegExp.$1);
            }
            else if (navigator.appName == 'Netscape') {
                const ua = navigator.userAgent;
                const re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                if (re.exec(ua) != null)
                    rv = parseFloat(RegExp.$1);
            }
            return rv;
        }

        static truncateLongText(originalText, maxLength): string {
            originalText.length > maxLength && (originalText = originalText.substring(0, (maxLength - 3)) + '...');
            return originalText;
        }

        static ECV_DATE_CONFIG = {
            todayDate: new Date(),
            clear: null,
            dateOptions: {
                formatYear: 'yy',
                startingDay: 1
            },
            altInputFormats: ['M!/d!/yyyy'],
            opened: false,
            class: () => {
                return 'ecv-dtpicker';
            }
        };

        static isJsonString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }

        static getPublicFileOrigin(ecareEnv: string) {
            return (ecareEnv == "my" ? Util.DOWNLOAD_IFRAME_ORIGIN_MY : Util.DOWNLOAD_IFRAME_ORIGIN) ;
        }

        /**
         * To add support for optional chaining expressions as AngularJS 1.6 does not have built-in support for it.
         * @param obj Object to check
         * @param properties Array of properties whose value is to be checked
         * @returns The value of the property if available or undefined
         */
        static safeAccess(obj, properties) {
            return properties.reduce(function(acc, property) {
                return acc && acc[property];
            }, obj);
        }

        static DOCSIZE_THRESOLD = 65 * 1024 * 1024;
        static DOWNLOAD_IFRAME_ORIGIN = "doc-store-ecarevault-com";
        static DOWNLOAD_IFRAME_ORIGIN_MY = "my-doc-store-ecarevault-com";
        static SPLASH_SCREEN_FILE = "/splash-screen.html";
        static DOWNLOAD_IFRAME_TAIL = "/download-document.html";
        static NO_MATCH_UISELECT = "No match";
        static PLEASE_SELECT_CR = "Please select a Team from the top menu to continue.";
        static TOS_UPDATE = "We have updated our account terms. Please review and agree below.";
        static TOS_CHECK_BOX = "I have read, understand, and agree to the updated ";
        static USER_TYPE_TOOLTIP = "We use this information to provide you a catered experience, aimed to help you get the most out of our application.";
        static INVITE_PERSONAL_MSG = "Please make sure you have appropriate permissions before inviting $user to $subject Team.";
        static OLD_INVITE_CANCEL_MSG = "The previous invitation sent to this Team Member will be cancelled and the most recent invite will be active.";
        static DO_IT_LATER = "DO IT LATER";
        static SEND_INVITE = "SEND INVITE";
        static INVITATION_SENT_SUCCESSFULLY = "Your invitation has been successfully sent.";
        static TEAM_MEMBER_ADDED_SUCCESSFULLY = "$user has been successfully added to $subject's Team";
        static PASSWORD_RESET_SUCCESS = "You have successfully reset your password.";
        static RESET_EMAIL_SUCCESS = "We have sent you an email with instructions to reset your password.";
        static VERIFICATION_EMAIL_SUCCESS = "We have sent you an email with the verification code.";
        static RESET_EMAIL_FAIL = "We could not send an email to the email address you have provided. Please try again or use a different email address";
        static PROMOTE_CO_CAPTAIN = "Are you sure you want to promote $user to Co-Captain? This means they can remove other Members from the Team and promote Members to the rank of Co-Captain.";
        static REMOVE_CO_CAPTAIN = "Are you sure you want to remove the Co-Captain badge from $user?";
        static REMOVE_CO_CAPTAIN_SELF = "Are you sure you want to remove the Co-Captain badge from yourself?";
        static CO_CAPTAIN_TOOLTIP = "Co-Captain can remove other Members from the Team and promote Members to the rank of Co-Captain.";
        static TEAM_CAPTAIN_TRANSFER_SUCCESSFULLY = "Team Captain badge for $subject Team successfully transferred to $user.";
        static SHARE_DOCUMENT_LABEL = "SHARE WITH MEMBERS";
        static SHARE_DOCUMENT_MSG = "Share the document with Team Members or skip this and share later.";
        static SHARE_DOCUMENT_PERMISSION = "Please make sure you have appropriate permissions to share with these Team Members.";
        static UPLOAD_DOCUMENT_BTN_SINGLE = "UPLOAD";
        static UPLOAD_DOCUMENT_BTN_MULTIPLE = "UPLOAD AND SHARE";
        static SHARE_DISCUSSION_LABEL = "INVITE TEAM MEMBERS";
        static SHARE_DISCUSSION_MSG = "Invite Team Members to the discussion or skip this and just leave yourself a note.";
        static SHARE_DISCUSSION_PERMISSION = "Please make sure you have appropriate permissions to add these Team Members.";
        static START_DISCUSSION_BTN_SINGLE = "START";
        static START_DISCUSSION_BTN_MULTIPLE = "START AND INVITE";
        static SHARE_WITH_FOLDER_TOOLTIP = "Sharing includes the ability to view and download the Document '$filename'";
        static SHARE_WITH_COMMENTS_TOOLTIP = "Sharing includes $commentCount comments and ability to participate in the Discussion '$docTitle'";
        static SHARE_WITH_DOC_WITH_DISC_INFO = "Any Team Members this document is shared with will also be invited to participate in the attached discussion.";
        static SHARE_WITH_DISC_WITH_DOC_INFO = "Any Team Member invited to this discussion will be able to view all previous comments and the attached document.";
        static SHARE_WITH_DISC_INFO = "Any Team Members invited to this discussion will be able to view all previous comments.";
        static SHARE_WITH_SECURITY_TOOLTIP = "<p>While eCare Vault is secure and private, held to the highest compliance standards, including HIPAA " +
            "(U.S. federal health care), FERPA (U.S. federal education) and CSPC (California Student Privacy Certification), " +
            "it is your responsibility to ensure that you have the appropriate permissions to share the information included in this displayAs." +
            "<br /><br />Please note that a displayAs, just like any other written correspondence, including email, is discoverable in a court of law.</p>";
        static SHARE_FORM_WITH_SECURITY_TOOLTIP = "<p>While eCare Vault is secure and private, held to the highest compliance standards, including HIPAA " +
            "(U.S. federal health care), FERPA (U.S. federal education) and CSPC (California Student Privacy Certification), " +
            "it is your responsibility to ensure that you have the appropriate permissions to share the information included in this Form." +
            "<br /><br />Please note that a Form, just like any other written correspondence, including email, is discoverable in a court of law.</p>";
        static SHARE_POPUP_ORG_USER_ADDED = "All set! <span class='base-blue-text'>${firstName}</span> was invited to the Team and will gain access as a member of <span class='base-blue-text'>${orgName}</span> upon accepting.";
        static SHARE_POPUP_NON_ORG_USER_ADDED = "All set! <span class='base-blue-text'>${firstName}</span> was invited to the Team and is ready for sharing.";
        static SETUP_SIGNATURE_SUCCESS = "User signature and initials have been setup successfully.";
        static FOLDER_CREATED_SUCCESSFULLY = "You have successfully created a new Folder.";
        static FOLDER_DUPLICATE_ERROR = "This Folder already exists";
        static FOLDER_DUPLICATE_ERROR_MOVE = "A Folder with this name already exists. Please enter a new name.";
        static FOLDER_CREATE_PARENT_SYS_ERROR = "You cannot create a new Folder within this Folder.";
        static FOLDER_NAME_EQUAL_TO_SYS_FOLDER_ERROR = "Folder name cannot be set to system folders name."
        static FOLDER_RENAMED_SUCCESSFULLY = "You have successfully renamed the Folder.";
        static FOLDER_DELETION_CONFIRMATION_POPUP = "Are you sure you want to delete this Folder?  Click DELETE to continue or NO to go back.";
        static DISABLED_DELETE_BUTTON_HOVER_TEXT = "You can only delete an empty folder.";
        static FOLDER_DELETED_SUCCESSFULLY = "You have successfully deleted this Folder.";
        static FOLDER_MOVED_SUCCESSFULLY = "You have successfully moved the Folder.";
        static DOCUMENT_MOVED_SUCCESSFULLY = "You have successfully moved the Document.";
        static DOCUMENT_COPIED_SUCCESSFULLY = "You have successfully copied the Document.";
        static SELF_EXIT_FROM_TEAM = "Are you sure you would like to leave $subject Team?";
        static ACCOUNT_LIMIT_POPUP_TITLE = "$entity Limit Reached";
        static ACCOUNT_LIMIT_POPUP_MESSAGE = "You have reached the maximum number of $entitys you $action. View the plan page and contact us for more information!";
        static TM_INVITE_MSG = "To keep things secure, only a Team Captain or Co-Captain can invite new Team Members. You can start a discussion with your Team's Captains to suggest additional Team Members.";
        static UPDATE_TEAM_MEMBER = "The Team Member has been updated in the $subjectType Team.";
        static ADD_CR_SUCCESS = "$subjectFullName Team created successfully.";
        static ADD_PROJECT_SUCCESS = "$subjectFullName Project created successfully.";
        static ADD_TM_SUCCESS = "$userFullName added to the team successfully.";
        static UPGRADE_DISABLED_MSG = "Interested in upgrading your plan? Please contact us at <a href='mailto:help@ecarevault.com'>help@ecarevault.com</a>.";
        static PAYMENT_DUE_POPUP_TITLE = "User Subscription Inactive";
        static PAYMENT_DUE_POPUP_MSG = "Oops! It seems we have run into an issue. Please update your billing information to continue using the application.";
        static FILE_SIZE_LIMIT_MSG = "File has a size greater than $fileSizeMB";
        static SUBSCRIPTION = `
            <h3 class="no-marg-bottom">eCare Vault offers à la carte features designed to drive the workflow of Professional and Enterprise customers<h3>
            <b>For Professionals and Enterprises</b>
            <ul>
                <li>Enhanced and direct Customer Service</li>
                <li>Customizable forms</li>
                <li>Service Tracking</li>
                <li>View-only sharing</li>
            </ul>
            <b>Exclusive to Enterprise Customers</b>
            <ul>
                <li>Employee Training</li>
                <li>User and Team onboarding</li>
                <li>Enterprise level permissions</li>
                <li>
            </ul>

            Contact us at <a href='mailto:enterprise@ecarevault.com'>enterprise@ecarevault.com</a> to learn more and get a quote.

        `;
        static EXISTING_USER_SUBS_POPUP_TITLE = "Exciting News!";
        static EXISTING_USER_SUBS_POPUP_MSG = "You are now able to select a subscription tier that best suits your needs! You may need to select a new plan by March 31st. Please click REVIEW to learn more.";
        static CANCEL_PLAN_POPUP_MSG = "Are you sure you want to cancel your current plan and enroll in the Care Giver (free) plan?";
        static CANCEL_PLAN_YES_CTA = "YES";
        static CANCEL_PLAN_NO_CTA = "NO";
        static CANCEL_PLAN_SUCCESS_MSG = "You have successfully cancelled your current plan and are now enrolled in the Care Giver (free) plan. Don't worry, you can continue to use the application for free as long as you would like!";
        static EFFECTIVE_PLAN_TEXT = "New plan in effect as of";
        static EFFECTIVE_PLAN_TOOLTIP = "$planName";
        static SELECT_PLAN_TOOLTIP = "Please select a plan!";
        static FREE_PLAN_TOOLTIP = "The free plan has no billing cycle.";
        static RECURRING_TOOLTIP = "This auto-renews at the start of the next billing cycle.";
        static MANAGE_PLAN_TEXT = "Manage Plan";
        static UPGRADE_PLAN_IN_EFFECT_TEXT = "Your new plan will go into effect immediately.";
        static DOWNGRADE_PLAN_IN_EFFECT_TEXT = "Your new plan will go into effect at the beginning of your next billing cycle.";
        static DOWNGRADE_PLAN_SUCCESS_MSG = "You will be charged for your new plan at the end of your current billing cycle.";
        static SHARE_STATUS_TOOLTIP_VO = `
                <p><i style="color:#288726;" class="fa fa-eye"></i>&nbsp;&nbsp;View-only sharing limits the Team Member to only viewing the Document within eCare Vault.</p>
                <p><i style="color:#288726;" class="fa fa-download"></i>&nbsp;&nbsp;View & Download will allow the Team Member to view the Document within eCare Vault or to download it.</p>`;
        static SHARE_STATUS_TOOLTIP = `
                <p>Sharing with a Team Member will allow them to:</p>
                <ul>
                    <li>Download the Document</li>
                    <li>View the document within eCareVault</li>
                    <li>Share it with other Team Members</li>
                </ul>`;


        static SHARE_STATUS_TOOLTIP_FORM_ASSIGNOR = `
                <p><i style="color:#288726;" class="fa fa-eye"></i>&nbsp;&nbsp;<b>View Form</b> sharing limits the Team Member to only viewing the Form within eCare Vault once it is submitted.</p>
                <p><i style="color:#288726;" class="fa fa-pencil"></i>&nbsp;&nbsp;<b>Fill</b> Out will allow the Team Member to fill the Form out, submit it, and share it.</p>`;
        static SHARE_STATUS_TOOLTIP_FORM_ASSIGNEE = `
                <p>Sharing with a Team Member will allow them to view the answers once the Form is submitted</p>`;

        static SHARE_COMMON_DOCUMENTS = "The selected documents will be automatically added to the Team Member's vault when the invitation is accepted.";
        static ASSIGN_FORM_SUCCESS = "You have successfully assigned the form.";
        static NO_FORM_SUBSCRIPTION = "Would you like to learn more about our Forms feature?  Please contact us at <a href='mailto:enterprise@ecarevault.com'>enterprise@ecarevault.com</a>."
        static EMPTY_SUBMITTED_BY_ME = "No forms yet! Check the Assigned Forms tab for any forms you need to complete.";
        static EMPTY_SUBMITTED_TO_ME = "No forms yet! Don't worry, we will let you know when someone submits a form.";
        static FORM_SAVE_SUCCESS = "Form saved successfully.";
        static FORM_SAVE_ERROR = "Unable to save the form. Please try again.";
        static FORM_ALREADY_SUBMITTED_RELOAD_MSG = "This form has already been submitted. No further changes can be made.";
        static FORM_ALREADY_SUBMITTED_ERROR = "Oops! Looks like this Form was submitted by another Team Member. You can view it on the Submitted Forms tab.";
        static ASSIGNED_FORM_DELETED = "This form has been deleted and cannot be saved or submitted.";
        static FORM_ALREADY_SIGNED_ERROR = "Oops! This Form was signed by another Team Member, however any answers you changed before signing will still be saved.";
        static FORM_SUBMIT_SUCCESS = "Form submitted successfully.";
        static FORM_CHANGES_NOT_SAVED = "Some changes are not saved. Are you sure you want to navigate away from this page?";
        static FORM_STATUS = {
            COMPLETED: "COMPLETED",
            NOT_STARTED: "NOT_STARTED",
            SUBMITTED: "SUBMITTED",
            IN_PROGRESS: "IN_PROGRESS"
        };
        static REMIND_NOW_SUCCESS = "Reminder sent successfully.";
        static REMIND_NOW_FAILURE = "Oops something went wrong, please try again."
        static FORM_VALIDATION_MSGS = {
            REGEX: "Invalid response",
            MIN_VALUE: "Please enter a higher number.",
            MAX_VALUE: "Please enter a lower number.",
            MIN_LENGTH: "Please enter a longer response.",
            MAX_LENGTH: "Please enter a shorter response.",
            MIN_DATE: "Please re-enter the date.",
            MAX_DATE: "Please re-enter the date.",
            MAX_FILES: "Upload limit exceeded.",
            INVALID: "Please enter a valid response.",
            INVALID_CHOICE: "Please select a response from the list.",
            REQUIRED: "Please enter a response.",
            ALREADY_EXISTS: "Value already exists.",
            EMPTY_VAL: "Value cannot be empty.",
            EMAIL_REGEX: "Must be a valid email address.",
            PHONE_REGEX: "Must match (XXX) XXX-XXXX.",
            NOT_AUTHORIZED: "You are not authorized to edit this field.",
            DEP_MIN_DATE : "Please re-enter the date.",
            DEP_MAX_DATE : "Please re-enter the date.",
            EQUAL_VALUE : "Values do not match."
        };
        static FORM_SUBMIT_MSGS = {
            INCOMPLETE: "Oops! Please complete the form before submitting.",
            GENERIC: "Oops, looks like there was an error, click submit to try again.",
            GETASSIGNMENT_FAIL: "Oops, looks like there was an error, click submit to try again.",
            NOT_ASSIGNEE: "Oops, looks like there was an error, click submit to try again.",
            UPDATE_FAILED: "Oops, looks like there was an error, click submit to try again."
        };
        static FORM_SUBMIT_TOOLTIP = "Please save the form before submitting.";
        static FORM_SIGN_SUBMIT_TOOLTIP = "Please sign and save the form before submitting.";
        static DELETE_ASSIGN_FORM = "You have successfully deleted the assigned form.";
        static RESTRICT_ASSIGN_FORM = "You are no longer part of this team. Please choose an active Team to assign this form.";
        static RESTRICT_ASSIGN_FORM_NOTTM = "You are not part of this team. Please choose an active Team to assign this form.";
        static No_ASSIGN_PERM_FORM = "You dont have assign permissions";
        static RESTRICT_ASSIGN_FORM_FROZEN = "Please choose an active Team to assign this form.";
        static RESTRICT_ASSIGN_OWN_TEAM = "You can only assign forms to your own team";
        static NO_ASSIGNED_FORMS_ENTERPRISE = "There are yet no forms assigned to $assignedTo and assigned by $assignedBy.";
        static NO_ASSIGNED_FORMS_NON_ENTERPRISE = "There are yet no forms assigned to $assignedTo.";
        static NO_SUBMITTED_FORMS_ENTERPRISE = "There are yet no forms submitted to $submittedTo and assigned by $assignedBy.";
        static NO_SUBMITTED_FORMS_NON_ENTERPRISE = "There are yet no forms submitted by $submittedTo.";
        static NO_ASSIGNEDTOME_FORM = "No forms yet! Don't worry, we will let you know when one is assigned to you.";
        static NO_ASSIGNEDBYME_FORM = "You haven't assigned any forms yet.";
        static EMPTY_AVAILABLE_FORM = "No forms yet! Please contact us at <a href='mailto:enterprise@ecarevault.com'>enterprise@ecarevault.com</a> to learn more.";
        static EMPTY_POST_SEARCH_RESUTLS = "There are no results that match the search criteria";
        static VAULT_KEY_TXT = "A Vault Key is a second password used to protect all the information you have stored in eCare Vault.";
        static FORM_SIGNED_SUCCESS = "Form signed successfully.";
        static FORM_SIGN_CONSENT = "The parties agree that this agreement may be electronically signed. The parties agree that the electronic signatures appearing on this agreement are the same as handwritten signatures for the purposes of validity, enforceability and admissibility.";
        static SETUP_SIGNATURE_CONFIRM = "By checking this box you agree that this signature may be used to electronically sign documents using our service.  You agree that electronic signatures appearing on an electronically signed agreement are the same as handwritten signatures for the purposes of validity, enforceability and admissibility.";
        static DELETE_TEAM = "Are you sure you want to delete $subject Team?";
        static PLAN_TYPE_ENTERPRISE = "ENTERPRISE";
        static ASSIGN_FORM_ERROR = "Unable to assign the form. Please try again.";
        static PENDING_INVITATIONS_MSG = "Hi $firstName you have $suffix. Review and accept now to start collaborating.";
        static ACTIVATE_PLAN_TEXT = "Activate Plan";
        static DOC_UPLOAD_INTERRUPTED = "Your document will not get uploaded. Are you sure you want to navigate away from this page?";
        static FORM_SUBMIT_UNAVAILABLE_INFO = "Please complete all required fields before submitting the form.";
        static FORM_SUBMIT_AVAILABLE_INFO = "Form is ready to be submitted.";
        static JOIN_TEAM_SUCCESS = "You have joined $subject Team.";
        static COCAPTAIN_JOIN_TEAM_SUCCESS = "You have joined $subject Team as a Co-Captain.";
        static SESSION_TIMEOUT_MSG = "Your session has timed out. Please login again.";
        static EMPTY_AVAILABLE_SERVICES = "No Services created.";

        static HELP_TEXT_SERVICE_CODE = "A unique code your organization uses to identify and keep track of this Service.";
        static HELP_TEXT_PROVIDER_TYPE = "An indication of the type of professional who will be providing the Service, to provide guidance the person who will be assigning it.";
        static HELP_TEXT_IS_LOCKED = "Locked fields cannot be altered when the Service is being assigned.";
        static HELP_TEXT_IS_REQUIRED = "Required fields must have a value when the Service is assigned. Either fill a Default Value to the right, or require it to be filled upon assignment.";
        static HELP_TEXT_DEFAULT_VALUE = "This will provide a value for this field when the Service is being assigned. If it is left blank, the field can be filled while assigning the Service, and if the field is locked a value must be provided here."
        static HELP_TEXT_FORMAT_LABEL = "Format determines whether this a group Service or individual therapy.";
        static HELP_TEXT_PROVIDERS = "Remove icon";
        static HELP_TEXT_RECIPIENTS = "Remove icon";
        static HELP_TEXT_FREQUENCY = "The number of times the service occurs within a cycle.";
        static HELP_TEXT_DURATION = "The length of time for each instance of the Service.";
        static HELP_TEXT_SETTING = "Remove icon";
        static HELP_TEXT_SDATE = "Remove icon";
        static HELP_TEXT_EDATE = "Remove icon";

        static BUILD_TEAM_FULLNAME_REQ = "Oops! Please enter both first name and last name of the invited Team Member to continue.";
        static BUILD_TEAM_INVALID_EMAIL = "Oops! Please enter a valid email address for the invited Team Member.";
        static BUILD_TEAM_INVALID_NAME = "Name contains invalid characters.";

        static SERVICE_CREATED_SUCCESSFULLY = "Service Created successfully.";
        static SAVE_FOR_LATER_CHANGES_SUCCESS = "Changes saved successfully.";
        static SERVICE_CREATION_ERROR = "Unable to create the service. Please try again.";

        static SHARE_SERVICE_WITH_SECURITY_TOOLTIP = "<p>While eCare Vault is secure and private, held to the highest compliance standards, including HIPAA " +
            "(U.S. federal health care), FERPA (U.S. federal education) and CSPC (California Student Privacy Certification), " +
            "it is your responsibility to ensure that you have the appropriate permissions to share the information included here." +
            "<br /><br />Please note any written correspondence, including email, is discoverable in a court of law.</p>";
        static CLOSE_SERVICE = "Are you sure you want to close the $service service?";
        static CLOSE_SERVICE_SUCCESS = "You have successfully closed this service.";
        static ASSIGN_SERVICE_SUCCESS = "You have successfully assigned the service.";
        static ASSIGN_SERVICE_ERROR = "Unable to assign the service. Please try again.";
        static UPDATE_ASSIGN_SERVICE_SUCCESS = "You have successfully updated the assigned service.";
        static UPDATE_ASSIGN_SERVICE_ERROR = "Unable to update the assigned service. Please try again.";
        static NO_CURRENT_SERVICES = "No services yet! Don't worry, we will let you know when one is assigned to you.";
        static NO_PREVIOUS_SERVICES = "Closed Services will appear in this tab.";
        static NO_SERVICE_NOTES_PROVIDER = "You have no Notes to view.  To enter a Note click 'ADD NOTE'";
        static NO_SERVICE_NOTES_VIEWER = "You have no Notes to view.";
        static NOTE_INCOMPLETE_STATUS = "Please complete all the required fields before submitting.";
        static NOTE_VALIDATION_ERROR = "Please correct any errors before submitting.";
        static FUTURE_SERVICE_DATE_ERROR = "A Note cannot be added for future date.";
        static NOTE_CREATED_SUCCESS = "Your Note has been successfully created!";
        static NOTE_UPDATED_SUCCESS = "Your Note has been updated.";
        static NOTE_DEACTIVATED_SUCCESS = "Your Note has been permanently de-activated.";
        static CANCEL_NOTE_MSG = "You will lose the data entered in the Note. Would you like to continue?";
        static INVITATION_ALREADY_USED = "Oops! You have already accepted this invitation. Continue logging in to begin collaborating!";
        static INVITATION_EXPIRED = "The invitation to join $subject's Team is no longer active. Create a Care Recipient or join another Team to get started!"
        static ASSOCIATE_TEAM_PROJECT = "Changes saved successfully.";
        static FAILURE_MSG = "Something went wrong, please try again.";
        static CARE_RECIPIENTS_NOT_FOUND = "The team you are trying to access does not exist.";
        static NO_ASSOCIATE_CR = "Please add more Care Recipients to add to the Project Team.";
        static NO_TEAM_MEMBER_SHARE_DOCUMENTS = "Please add a Team Member to the Team to share this Document.";
        static NO_TEAM_MEMBER_SHARE_DOCUMENT_NEW = "Select Upload to continue without sharing.";
        static NO_TEAM_MEMBER_SHARE_DISCUSSIONS = "Please add a Team Member to the Team to start a Discussion or just leave yourself a note!";
        static NO_TEAM_MEMBER_SHARE_DISCUSSION_NEW = "Select Start to continue without sharing.";
        static NO_TEAM_MEMBER_SHARE_SERVICES = "Please add a Team Member to the Team to share this displayAs.";
        static NO_TEAM_MEMBER_SHARE_FORMS = "Please add a Team Member to the Team to share this Form.";
        static CONFIRM_DEASSOCIATE_TM = "Are you sure you would like to remove this Care Recipient? " +
            "Since you are not part of the Care Recipient's team you will not be able to add them to this project in the future.";
        static DELETE_EVENT = "Are you sure you want to delete this event?";
        static NO_EVENTS = "There are no events scheduled on this day.  Click Add Event if you would like to create one.";
        static NO_MODULE_PERM = "$moduleName are not available for teams owned by $orgName.";
        static NO_MODULE_PERM_FOR_ORG = "$moduleName are not available to $orgName users.";
        static NO_MODULE_TM_INVITE_MSG = "To keep things secure, only a Team Captain or Co-Captain can invite new Team Members.";
        static IN_AUTH_VALIDATION_MSG = "Please correct the below mentioned errors before submitting.";
        static COVER_SHEET_INSTRUCTIONS = "To fax documents into eCare Vault, print the cover sheet, fax documents to yourself or share a link for the cover sheet -anyone may use the cover sheet to upload documents in a HIPAA compliant manner.";
        static COVER_SHEET_LINK_TEXT = "Click this link to preview the page generated for this cover sheet";
        static COVER_SHEET_FOOTER_MSG = "Faxing with eCare Vault can only be used to upload a document into the application, there is no way to access personal data using this cover sheet.";
        static PDF_URL = 'https://$$bucketName$$/$$fileName$$';
        static NO_UPLOADS = "No documents have been received yet. Please click refresh to check the status.";
        static COVER_SHEET_UPLOADS_INSTRUCTIONS = "<p>Follow the steps below to fax documents into eCare Vault." +
            "<ol><li>Print the cover sheet.</li><li>Place the cover sheet on top of and in the same direction as the documents you are faxing.</li>" +
            "<li>Separate documents by placing a blank sheet of paper between them.</li>" +
            "<li>Fax the cover sheet and documents to the number listed.</li></ol></p>";
        static DOCS_PROCESSING = "Documents may still be processing.";
        static SELECT_VIEW_MSG = "<div>Click here to select and view the Team.</div>";
        static ACCEPT_INVITATION_POPUP = Util.SELECT_VIEW_MSG + "<div>" + Util.DOCS_PROCESSING + "</div>";
        static ACCEPT_INVITATION_VIEW_POPUP = "<div>Click here to view the Team.</div><div>" + Util.DOCS_PROCESSING + "</div>";
        static NOTIFICATION_FOR_OTHER_USER = "Oops! This notification was meant for a previous user.";
        static DESKTOP_NOTIFICATION_NOT_SUPPORTED = "Desktop notifications are not available with this browser. Please use a different browser to enable desktop notifications.";
        static DTD_VALUES = "This will provide a value for this field when the Form is being assigned. You can change the value of form configuration if they are not locked";
        static ROW_COUNT_HELP = "How many rows of trials are in the form?";
        static TRIAL_ROW_DELETE = "You have chosen options that will delete a filled field, do you want to continue?";
        static DOC_DWNLD_PROGRESS = "Document download is in progress. Are you sure you want to logout and cancel all downloads?";
        static DOC_UPLD_PROGRESS = "Document upload is in progress. Are you sure you want to logout and cancel all uploads?";
        static DOC_UPLD_LEAVE_PROGRESS = "Are you sure you want to leave? There is still a document upload in progress. Leaving this page may cancel the upload.";
        static FORM_UPLD_PROGRESS = "A form upload is in progress. If you leave now the upload will be canceled and the document won't be saved to the team. Are you sure you want to leave?";
        static EXIT_TEAM_TOASTR = "You have been removed from $subject. Click here to log out and refresh the application to view the changes."
        static RESHARE_FORMER_ACTIVE_USER = "This Team Member does not have access to the most recent version of this displayAs. You can re-share it with them if they need updated access or the ability to share the displayAs on their own.";
        static RESHARE_FORMER_ACTIVE_ORG = "This Care Org has access to a previous version of this Document. Click “Update” to share the most current version or to allow them to share the Document.";
        static RESHARE_FORMER_USER = "This former Team Member can still access this displayAs but cannot share or change it.";
        static RESHARE_FORMER_ORG = "This former Care Org can access the Document but cannot share or change it.";
        static RESHARE_FORM_FORMER_USER = "This former Team Member can still access this form submission but cannot share it.";
        static RESHARE_DELETED_INFO = "This Team Member does not have access to the most recent version of this displayAs. You can re-share it with them if they need updated access or the ability to share the displayAs on their own.";
        static RESHARE_DELETED_INFO_ORG = "Members of this Care Org no longer have access to the most recent version of this displayAs";
        static RESHARE_DELETED_DOC = "Click 'Confirm' to complete the re-sharing of ${itemTitle} with ${tmName}.";
        static NO_SHARED_USERS_MSG = "This displayAs has not been shared with anyone! Only you can see it."
        static DELETE_CONFIRM = "Are you sure you want to delete this document? Click again to delete.";
        static DELETE_CONFIRM_ORG = "Deleting this document will remove access for your entire Care Org. Click again to continue deleting the document.";
        static SHARE_TITLE = "Share $displayAs";
        static SHARE_UPLOAD_TITLE = "Upload and Share";
        static SHARE_INVITE_TITLE = "Start and Invite";
        static SHARE_TITLE_DISCUSSION = "Add Members to Discussion";
        static NO_SHARED_USERS_DOCUMENT = "This document has not been shared with anyone! Only you can see it.";
        static NO_SHARED_USERS_DISCUSSION = "This discussion has no participants. Only you can see it.";
        static NO_SHARED_USERS_FORM = "No one else has access to this assigned form. Only you can see it.";
        static NO_SHARED_USERS = "This $displayAs has not been shared with anyone! Only you can see it."
        static SELECT_TM_TITLE_DISC = "Choose Team Members to Add";
        static SELECT_TM_TITLE = "Choose Team Members to Share With";
        static SHARED_AREA_TITLE = "Team Members with access";
        static MULTIPLE_SHARED_AREA_TITLE = "The documents will be shared with the below Team Members";
        static SHARED_AREA_TITLE_DISC = "Participants in this $displayAs";
        static AUTHOR_INFO_DOC = "Uploaded on $date by ";
        static AUTHOR_INFO_DISC = "Started on $date by ";
        static AUTHOR_INFO = "Assigned by ";
        static AUTHOR_INFO_NOTE = "Created by ";
        static SHARE_TITLE_FORM = "Share or Assign Form";
        static GDPR_COMPLIANCE_INFO = "To improve user experience eCare Vault gathers basic information about the device you use to access the service to anonymize and share with third party vendors and processes Personal and Sensitive Personal Data. By clicking 'Agree' below you agree to the above and to the <a href='http://downloads.ecarevault.com/downloads/eCare+Vault+-+Terms+of+Service.pdf' target='_blank'>Terms of Service</a>, <a href='http://downloads.ecarevault.com/downloads/eCare+Vault+-+Privacy+Policy.pdf' target='_blank'>Privacy Policy</a>, and  <a href='http://downloads.ecarevault.com/downloads/eCare+Vault+-+Eu+Privacy+Notice.pdf' target='_blank'>EU Privacy Notice</a>.";
        static GDPR_COMPLIANCE_DECLINE_CASE_INFO_SIGNUP = "If you decline you will be unable to sign up for or use the eCare Vault service.";
        static GDPR_COMPLIANCE_DECLINE_CASE_INFO_LOGIN = "If you decline you will be unable to Login for or use the eCare Vault service.";
        static DTT_FORM_INFO = "Your organization does not manage this team. You cannot assign a form with Analytics to the team."
        static UPLOAD_LIMIT_EXCEEDED = "Upload limit exceeded. Any files after the first $limit have been discarded.";
        static UPLOAD_LIMIT_EXCEEDED_SHRT = "Upload limit exceeded.";
        static CORRECT_ERRORS = "Please correct any errors and try again";
        static ACCOUNT_UPLOAD_LIMIT_MESSAGE = "You have reached the maximum number of $entitys you $action.";
        static FILES_DISCARDED = " Any files after the first $limit have been discarded.";
        static CANCEL_SELF_ASSIGN_FORM = "Self-Assign & Go Canceled. A Team is required to assign the form.";
        static FORM_NOT_AVAILABLE = "The form you selected is not available for this team.";
        static ASSIGN_FORM_INACTIVE_TEAM = "You must be an active team member to assign forms.";
        static VIEW_IN_BROWSER_NOT_ALLOWED_LG_DOC = "This Document is too large for in-app preview.  To view the document please download it.";
        static SIGNATURE_NOT_ALLOWED_LG_DOC = "This Document is too large to be signed within eCare Vault.";
        static IE_DOWNLOAD_NOT_ALLOWED_LG_DOC = "This Document is too large to download from eCare Vault using Internet Explorer. Please try again with Google Chrome or Mozilla Firefox.";
        static IE_UPLOAD_NOT_ALLOWED_LG_DOC = "This file is too large to upload to eCare Vault using Internet Explorer. Please try again with Google Chrome or Mozilla Firefox.";
        static LG_DOC_DOWNLOAD_TRAY_MESSAGE = "Due to size this Document is downloading directly through the browser.";
        static FORM_SUBMIT_ERROR = "Unable to submit the form at this time. Please try again later.";
        static FORM_VALIDATION_ERROR = "Please correct any errors and submit the form again.";
        static TEAM_FROZEN_SUCCESSFULLY = "Team frozen successfully";
        static TEAM_THAWED_REQ_SUBMITTED = "Thank you for submission. eCare Vault Customer Support will reach out in case of any issues or questions regarding the justification.";
        static EMAIL_EXISTS = "We cannot create a new account for this email address. Please try logging in or contact support for assistance.";
        static WORKFLOW_PENDING_MIGRATION_TEXT = "You can assign this student to a new Team or update an already existing Team with new information from the Form.";
        static WORKFLOW_FAILURE_MSG = "Could not $action due to an unexpected error. Please contact support if the issue persists.";
        static WORKFLOW_TEXT = "The Providers below will be assigned to the $to based on the submitted $from:";
        static WORKFLOW_ASSIGN_SERVICE_TEXT = "Do you want to assign the service(s) from this form to $studentName";
        static NOTE_DELETE_MSG = "Are you sure you want to de-activate this Service Note? This cannot be undone. Click again to continue.";
        static USER_DEACTIVATE_MSG = "Are you sure you want to de-activate this user? This cannot be undone. Click again to continue.";
        static WORKFLOW_CANCEL_TEXT = "To make a change please click <b>Close</b> and edit the submitted form.";
        static OPN_NEW_TAB_MSG = "Click to open this link in a new tab. You will not be logged into or able to log out of eCare Vault from the new tab. Return to this tab to continue using eCare Vault or to logout.";
        static HELP_TAB_MSG = "Click to open this link in a new tab. Return to this tab to continue using eCare Vault or to logout.";
        static TRANSFER_OWNERSHIP_AS_ADMIN_TEXT = "Please transfer the Team Captain badge to another Team Member before removing this Team member from the Team.";
        static TRANSFER_OWNERSHIP_AS_ADMIN_TOOLTIP = "By transferring the Team Captain badge you are transferring ownership and full management of the Team.";
        static CLIENT_POPUP_HEADERTEXT = "This is the client’s temporary password for Safe Passages. Please immediately give the password to the client or make a copy. Once this pop-up closes you will no longer have access to this password.";
        static CANCEL_SHARE = "Share document Canceled. A Team is required to share the document.";
        static COLORS = {
            "primaryText":"#2A272D",
            "lightText":"#777470",
            "ecvBlue":"#2360A7",
            "ecvOrange":"#F89A44"
        };
        static DOC_NO_CONTENT = "The file you are trying to upload has no content. Please try uploading a different file.";
        static INVALID_DATE = "Invalid Date format";
        static REMOVE_CAREITEM_MSG= "This will remove this activity from your list. Click again to continue.";
        static INCORRECT_INPUT = "Please enter valid input.";
        static NO_RELEVANT_INFO = "Sorry, I couldn't find any relevant information.";
        static SOMETHING_WENT_WRONG = "Sorry, something went wrong while getting that. Could you try again?";
    }

